/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-14 09:53:18
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types'
import s from '../form.css';
import { parseArrayToTable, parseStringToArray } from '../utils';
import classnames from 'classnames';
import { drop, head } from 'lodash';
import { getVisual } from '../../../controller';

const defaultColorValue = `
品牌世界杯总DB值	#009599
官方自媒体世界杯DB值	#ffc000
`

class Form extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    children: PropTypes.node,
  }
  constructor(props) {
    super(props);

    this.state = {
      value: '',
      colorValue: defaultColorValue,

      dataset: [],
      tableColumns: [],
      tableList: [],

      chartTitle: [],
      chartList: [],
      chartColorList: [],
    }
  }

  componentDidMount () {
    this.loadData();
  }

  loadData = () => {
    const { onChange } = this.props;

    getVisual('23').then(value => {
      const _table = Form.parse(value);
      const _tempColor = Form.parseColor(defaultColorValue);

      this.setState({
        value: value,
        ..._table,
        ..._tempColor
      })
  
      typeof onChange === 'function' && onChange({
        ..._table,
        ..._tempColor
      });
    });
  }

  static parse = (str) => {
    const dataset = parseStringToArray(str);
    if (!dataset) return null;

    const { columns, list } = parseArrayToTable(dataset, {});

    if (columns && columns.length > 0) {
      columns[0].style = { width: 90 }
    }

    return {
      dataset,
      tableColumns: columns,
      tableList: list,
      ...Form.parseChart(dataset),
    }
  }
 
  static parseChart = (dataset = []) => {
    const source = [...dataset];
    const axis = drop(head(source), 1);
    const result = [];
    const ddd = drop(source, 1);

    axis.forEach((item, index) => {
      result[index] = { title: item, list: [] };
      const value1 = (ddd[0][index + 1] || '').replace(/[\s|\D]/g, '');
      const value2 = (ddd[1][index + 1] || '').replace(/[\s|\D]/g, '');

      result[index].list.push({ name: ddd[0][0], value: parseFloat(value1) })
      result[index].list.push({ name: ddd[1][0], value: parseFloat(value2) })
    })

    return { chartTitle: axis, chartList: result }
  }

  static parseColor = (str) => {
    const dataset = parseStringToArray(str);

    return { chartColorList: dataset.map(item => item[1]) }
  }

  onChange = (e) => {
    const { onChange } = this.props;
    const value = e.target.value;
    const tableData = Form.parse(value);
    this.setState({ value, ...tableData });

    typeof onChange === 'function' && onChange(tableData)
  }

  onChangeColor = (e) => {
    const { onChange } = this.props;
    const value = e.target.value;
    const _color = Form.parseColor(value);
    const result = {
      ..._color,
      ...Form.parse(this.state.value, _color.tableColorList),
    }
    this.setState({
      colorValue: value,
      ...result,
    })

    typeof onChange === 'function' && onChange(result)
  }

  render() {
    return (
      <div className={s.root}>
        <div>数据设置</div>
        <textarea className={classnames(s.inputText)} value={this.state.value} onChange={this.onChange} />
      </div>
    );
  }
}

export default withStyles(s)(Form);



// WEBPACK FOOTER //
// src/routes/visualChart/P23/Form.js